<template>
<section class="container">
  <section class="panel center-block">
      <div class="container-fluid">
     
            <!-- CACHER SI PAS TESTEUR-->
            <div class="text-center">
              <router-link class="btn btn-warning" to="/ListeQuestions">&lsaquo;&lsaquo; Retour</router-link>
            </div>
              <!-- CACHER SI PAS TESTEUR-->
            <div class="countdown">
                <canvas id="pie-countdown" width="80" height="80" class=""></canvas>
              <canvas id="pie-background" width="86" height="86"></canvas>
              <span class="points">10<br>points</span>
              <span class="pulse1"></span>
              <span class="pulse2"></span>
          </div>

        <h1 class="sep mt-3">Question of the day</h1>
        <p class="hauracherell">Combien compte de marches la tour eiffel ?</p>
        <div class="video__player mt-4">
          <div>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/K-P1BX3-4AE" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>          
          </div>
        </div><!-- VIDEO PLAYER-->
         <div class="field mt-5">
        <input type="text" class="bg-light" placeholder="Votre réponse..."/>
        </div>
          <button class="btn btn-primary w-100" v-on:click="modalOpen_required = ! modalOpen_required"><i class="icon thumb-up-white"></i> Valider ma réponse</button>
      </div>
  </section><!-- PANEL -->
  <span class="panel-bottom"></span>
   <section class="modal" v-bind:class="{ modalopen: modalOpen_required }">
      <div class="modal-content bg-danger">
          <p class="text-center">
            <i class="icon smiley-tongue"></i>
          </p>
          <p>Attention, pour relever le défi de la question du jour, vous devez quand même y répondre!</p>
          <div class="text-center">
            <button class="btn btn-border-white" v-on:click="modalOpen_required = ! modalOpen_required">Fermer la fenêtre</button>
            </div>
        </div>
  </section><!-- MODAL-->
</section><!-- CONTAINER FLUID-->
</template>
<script>
export default {
  data: function() {
    return {
      modalOpen_required: false,
    };
    },
    mounted: function () {
      var _self = this;
      _self.$parent.GloablEvents();
      
    }
    
  
};
</script>
<style lang="scss" scoped>
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
